import { makeId } from '../..'
import { URL_JUSBRASIL } from '../../static-fields'
import { SEOItemList } from '../../types'

export interface SEONavigationItemListElementInput {
  url: string
  name: string
}

export interface SEONavigationItemListInput {
  canonicalUrl?: string
  itemListElement: SEONavigationItemListElementInput[]
}

export const getNavigationList = ({
  canonicalUrl,
  itemListElement,
}: SEONavigationItemListInput): SEOItemList => ({
  '@id': makeId(canonicalUrl ? canonicalUrl : URL_JUSBRASIL, 'navigation'),
  '@type': 'ItemList',
  itemListElement: itemListElement.map(({ url, name }) => ({
    '@type': 'SiteNavigationElement',
    name,
    url,
  })),
})
